export default __webpack_public_path__ + "static/media/titanic.54815cd5.jfif";